import { Card, Grid, Stack, Tooltip } from "@mui/material";
import VuiBox from "components/VuiBox";
import VuiTypography from "components/VuiTypography";
import VuiProgress from "components/VuiProgress";
import BarChart from "examples/Charts/BarCharts/BarChart";
import { barChartDataDashboard } from "layouts/dashboard/data/barChartData";
import { barChartOptionsDashboard } from "layouts/dashboard/data/barChartOptions";
import linearGradient from "assets/theme/functions/linearGradient";
import colors from "assets/theme/base/colors";
import { FaFileAlt, FaShieldAlt, FaExclamationTriangle, FaUserSecret } from "react-icons/fa";
import { useEffect, useState } from "react";
import { api } from "services/api"; // Importar o serviço de API
import { logger } from "services/logger"; // Importar o logger

const StatItem = ({ icon, title, tooltip, value }) => (
  <Grid item xs={6} md={3} lg={3}>
    <Tooltip title={tooltip} placement="top">
      <Stack direction="row" spacing={{ sm: "10px", xl: "4px", xxl: "10px" }} mb="6px">
        <VuiBox
          bgColor="info"
          display="flex"
          justifyContent="center"
          alignItems="center"
          sx={{ borderRadius: "6px", width: "25px", height: "25px" }}
        >
          {icon}
        </VuiBox>
        <VuiTypography color="text" variant="button" fontWeight="medium">
          {title}
        </VuiTypography>
      </Stack>
    </Tooltip>
    <VuiTypography color="white" variant="lg" fontWeight="bold" mb="8px">
      {value}
    </VuiTypography>
    <VuiProgress value={100} color="info" sx={{ background: "#2D2E5F" }} />
  </Grid>
);

const ActiveUsers = ({ stats, chartData, chartOptions }) => {
  const { gradients } = colors;
  const { cardContent } = gradients;

  

  return (
    <Card>
      <VuiBox>
        <VuiBox
          mb="24px"
          height="220px"
          sx={{
            background: linearGradient(
              cardContent.main,
              cardContent.state,
              cardContent.deg
            ),
            borderRadius: "20px",
          }}
        >
          <BarChart
            barChartData={[{ name: 'Leads', data: chartData }]}
            barChartOptions={barChartOptionsDashboard}
          />
        </VuiBox>
        <VuiTypography variant="lg" color="white" fontWeight="bold" mb="5px">
          Visão Geral da Semana
        </VuiTypography>
        <VuiBox display="flex" alignItems="center" mb="40px">
          <VuiTypography variant="button" color="text" fontWeight="regular">
            Dados coletados nos últimos 7 dias.
          </VuiTypography>
        </VuiBox>
        <Grid container spacing="50px">
          <StatItem 
            icon={<FaFileAlt color="#fff" size="12px" />} 
            title="Leads" 
            tooltip="Total de Leads" 
            value={stats ? stats.leads.value : '...'}
          />
          <StatItem 
            icon={<FaShieldAlt color="#fff" size="12px" />} 
            title="B.Risco" 
            tooltip="Leads de Baixo Risco" 
            value={stats ? stats.baixoRisco.value : '...'}
          />
          <StatItem 
            icon={<FaExclamationTriangle color="#fff" size="12px" />} 
            title="L.Susp." 
            tooltip="Leads Suspeitos" 
            value={stats ? stats.suspeitos.value : '...'}
          />
          <StatItem 
            icon={<FaUserSecret color="#fff" size="12px" />} 
            title="Fraudadores" 
            tooltip="Fraudadores Identificados" 
            value={stats ? stats.fraudadores.value : '...'}
          />
        </Grid>
      </VuiBox>
    </Card>
  );
};

export default ActiveUsers;
